export const wishlistAddcart = () => {
    window.addEventListener('load', () => {
        
    const swymContainer = document.querySelector('#swym-wishlist-render-container');

    // MutationObserverのコールバック関数
    const callback = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            if (mutation.addedNodes[0] && mutation.addedNodes[0].className == 'swym-wishlist-detail-content') {
                const targetNode = mutation.addedNodes[0];
                const addCartButtons = Array.from(targetNode.querySelectorAll('.swym-add-to-cart-btn'));
                addCartButtons.forEach( (button) => {
                    button.addEventListener( 'click', () => {
                        setTimeout(function() {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true
                            }));
                        }, 1000)                        
                    })
                })
            }
        }
        }
    };
    
    // MutationObserverの設定
    const observer = new MutationObserver(callback);
    
    // 監視する要素とオプションを指定
    const targetNode = swymContainer; // 監視する要素を適切に指定する
    const config = { childList: true, subtree: true };
    
    // MutationObserverを開始
    observer.observe(targetNode, config);

    })
}